
export interface EntityInfo {
    acronym: string;
    entity: string;
}
export const entityMap: EntityInfo[] = [
    { "acronym": "HBG", "entity": "Highmark Benefits Group" },
    { "acronym": "HBCBS", "entity": "Highmark Blue Cross Blue Shield" },
    { "acronym": "HBS", "entity": "Highmark Blue Shield" },
    { "acronym": "HCA", "entity": "Highmark Coverage Advantage" },
    { "acronym": "HHIC", "entity": "Highmark Health Insurance Company" },
    { "acronym": "FPLIC", "entity": "Priority Life Insurance Company" },
    { "acronym": "FPH", "entity": "First Priority Health" },
    { "acronym": "HMDE", "entity": "Highmark Blue Cross Blue Shield" },
    { "acronym": "HMWV", "entity": "Highmark Blue Cross Blue Shield" },
    { "acronym": "HWNY", "entity": "Highmark Blue Cross Blue Shield" },
    { "acronym": "HNENY", "entity": "Highmark Blue Shield" },
    { "acronym": "DENTAL_WPA", "entity": "Highmark Health Insurance Company" },
    { "acronym": "DENTAL_CPA", "entity": "Highmark Health Insurance Company" },
    { "acronym": "DENTAL_NEPA", "entity": "First Priority Life Insurance Company" },
    { "acronym": "DENTAL_SEPA", "entity": "Highmark Health Insurance Company" },
    { "acronym": "DENTAL_WV", "entity": "Highmark West Virginia Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "DENTAL_DE", "entity": "Highmark BCBSD Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "DENTAL_WNY", "entity": "Highmark Western and Northeastern New York Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "DENTAL_NENY", "entity": "Highmark Western and Northeastern New York Inc. d/b/a Highmark Blue Shield" },
    { "acronym": "BEB_WPA", "entity": "Highmark Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "BEB_CPA", "entity": "Highmark Inc. d/b/a Highmark Blue Shield" },
    { "acronym": "BEB_NEPA", "entity": "Highmark Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "BEB_SEPA", "entity": "Highmark Inc. d/b/a Highmark Blue Shield" },
    { "acronym": "BEB_WV", "entity": "Highmark West Virginia Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "BEB_DE", "entity": "Highmark BCBSD Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "BEB_WNY", "entity": "Highmark Western and Northeastern New York Inc. d/b/a Highmark Blue Cross Blue Shield" },
    { "acronym": "BEB_NENY", "entity": "Highmark Western and Northeastern New York Inc. d/b/a Highmark Blue Shield" }
];